import { ErrorTokenization } from './error';
var ccAlpha = 'A-Za-z';
var ccDigit = '0-9', ccNonZeroDigit = '1-9';
var ccAlphanum = "" + ccAlpha + ccDigit;
var cSpace = ' ';
var cDelim = "" + cSpace;
var gEscapeText = "[" + ccAlphanum + "][" + ccAlphanum + cSpace + "]*";
var gEscape = "@#(?:" + gEscapeText + ")@";
var gIdentifierString = "[" + ccAlphanum + "-]+"; // x: Allow '-'
var gLevel = "[" + ccNonZeroDigit + "][" + ccDigit + "]+|[" + ccDigit + "]";
var ccDisallowed = '\\x00-\\x08\\x0A-\\x1F'; // x: include \xFF
var cCR = '\\r', cLF = '\\n';
var gLineChar = "[^" + ccDisallowed + cCR + cLF + "@]|@"; // x: Allow single at
var gLineText = "(?:" + gLineChar + ")*"; // x: Allow empty strings
var gLineItem = gEscape + "|" + gLineText + "|" + gEscape + "[" + cDelim + "]" + gLineText;
var gXRefId = "@" + gIdentifierString + "@";
var gPointer = "" + gXRefId;
var gLineValue = gPointer + "|(?:" + gLineItem + ")";
var gTag = "[" + ccAlphanum + "]+|_[" + ccAlphanum + "_]+"; // TODO
var gTerminator = cCR + "?" + cLF;
var gGedcomLine = "(" + gLevel + ")(?:" + cDelim + "(" + gXRefId + "))?" + cDelim + "(" + gTag + ")(?:" + cDelim + "(" + gLineValue + "))?(?:" + gTerminator + ")";
/**
 * The tokenizer implementation.
 * Processes a file stored as a string, line by line, according to the `gGedcomLine` regular expression.
 * A parameter in the constructor decides whether to raise an error when a line cannot be parsed or to fail silently.
 * Code was not extracted further as a performance tradeoff.
 */
var GedcomTokenizer = /** @class */ (function () {
    function GedcomTokenizer(input, strict) {
        this.input = input;
        this.strict = strict;
        this.rGedcomLines = new RegExp("^" + gGedcomLine, 'gym'); // Must be newly created
        this.linesRead = 0;
        this.charactersRead = 0;
    } // eslint-disable-line no-useless-constructor
    GedcomTokenizer.prototype[Symbol.iterator] = function () {
        return this;
    };
    GedcomTokenizer.prototype.next = function () {
        var result = this.rGedcomLines.exec(this.input);
        if (result === null) {
            var success = this.charactersRead === this.input.length;
            if (this.strict && !success) {
                var printCharactersMax = 256; // Avoid printing a super long line
                var errorLine = this.input.substring(this.charactersRead, Math.min(this.charactersRead + printCharactersMax, this.input.length)).split(/[\r\n]+/, 1)[0];
                throw new ErrorTokenization("Invalid format for line " + (this.linesRead + 1) + ": \"" + errorLine + "\"", this.linesRead + 1, errorLine);
            }
            return { done: true, value: null }; // Return
        }
        else {
            this.charactersRead += result[0].length; // Includes terminator
            this.linesRead++;
            return { done: false, value: result }; // Yield
        }
    };
    return GedcomTokenizer;
}());
/**
 * Processes the input string and return a tokenized, line by line, high-level representation.
 * @param input The input file, represented as a single string
 * @param strict When set to <code>false</code> any parsing exception will not be reported
 */
export var tokenize = function (input, strict) {
    if (strict === void 0) { strict = true; }
    return new GedcomTokenizer(input, strict);
};
//# sourceMappingURL=tokenizer.js.map